import { Link } from "wouter";
import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { Skeleton } from "@sfc/ui";

export function ApplicationHeader({
  roundName,
  teamName,
  teamId,
  backLabel = "Back to Application",
  action,
  onBack,
  backDisabled = false,
  status,
}: {
  roundName?: string;
  teamName?: string;
  teamId?: string;
  backLabel?: string;
  action?: ReactNode;
  onBack?: () => void;
  backDisabled?: boolean;
  status?: ReactNode;
}) {
  return (
    <header className="sticky top-0 z-10 space-y-4 border-b border-border bg-background py-4">
      <div className="flex min-h-9 items-center justify-between gap-4">
        <button
          type="button"
          onClick={onBack}
          disabled={backDisabled || !onBack}
          className="inline-flex min-h-9 items-center gap-2 rounded-sm body-sm text-primary hover:underline underline-offset-4 focus-visible:outline-2 focus-visible:outline-ring disabled:opacity-50 disabled:no-underline"
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          {backLabel}
        </button>
        {action}
      </div>
      <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-3">
        <div className="min-w-0 flex-1 space-y-2">
          {roundName ? (
            <h1 className="heading-lg [overflow-wrap:anywhere]">{roundName}</h1>
          ) : (
            <Skeleton
              className="h-8 w-2/3 motion-reduce:animate-none"
              aria-hidden="true"
            />
          )}
          {teamName ? (
            <p className="body-sm text-muted-foreground [overflow-wrap:anywhere]">
              Team{" "}
              {teamId ? (
                <Link
                  href={`/teams/${encodeURIComponent(teamId)}`}
                  className="ml-1 font-medium text-foreground underline underline-offset-4"
                >
                  {teamName}
                </Link>
              ) : (
                <span className="ml-1 font-medium text-foreground">
                  {teamName}
                </span>
              )}
            </p>
          ) : (
            <Skeleton
              className="h-5 w-40 motion-reduce:animate-none"
              aria-hidden="true"
            />
          )}
        </div>
        <div className="min-h-5 max-w-sm space-y-2 body-sm text-muted-foreground sm:text-right">
          {status ?? (
            <Skeleton
              className="h-5 w-16 motion-reduce:animate-none"
              aria-hidden="true"
            />
          )}
        </div>
      </div>
    </header>
  );
}
